import client from './client'

const apiBasePath = '/api/group/account/entry/'

export default {
  detail: entryForm => client.post(apiBasePath + 'detail', entryForm),
  search: () => client.post(apiBasePath + 'search'),
  approve: entryForm => client.post(apiBasePath + 'approve', entryForm),
  reject: entryForm => client.post(apiBasePath + 'reject', entryForm)
}
